import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'reactstrap';

import Icon, { faCircleExclamation } from '~components/icon';

const AccessDenied: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [buttonDetails, setButtonDetails] = useState({ text: '', url: '' });

  useEffect(() => {
    const type = searchParams.get('type');
    switch (type) {
      // support-coordination
      case '1':
        setMessage('You do not have permission to view or update support coordination');
        setButtonDetails({ text: 'Back to Appointments', url: '/appointments' });
        break;
      default:
        setMessage('You do not have permission to view this page');
        setButtonDetails({ text: 'Back to Home', url: '/' });
        break;
    }
  }, [searchParams]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center h-100" data-cy="access-denied">
      <Icon icon={faCircleExclamation} size="4x" />
      <h1 className="mt-4">401 - Access Denied</h1>
      <p className="mt-4">{message}</p>
      <Button
        data-cy="re-direct-button"
        onClick={() => {
          navigate(buttonDetails.url);
        }}
      >
        {buttonDetails.text}
      </Button>
    </div>
  );
};

export default AccessDenied;
